import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base/services';
import { SessionService, StepsIdEnum, ConstantsService, RequestTypesEnum, LookupsService, StepsRouteEnum, StepsCodeEnum } from '@app/base/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CanComponentDeactivate, UspsService, compareObjects, focusFirstInvalidField } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SocoHttpService } from '@app/base/soco';
import { AlertService } from '@app/base/alerts/alert.service';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.css']
})
export class AddressesComponent implements OnInit, AfterViewInit, CanComponentDeactivate, OnDestroy {
  form: FormGroup;
  alertMsg: any = [];
  locationform: FormGroup;
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  stepsCodeEnum: typeof StepsCodeEnum = StepsCodeEnum;
  requestTypeEnum: typeof RequestTypesEnum = RequestTypesEnum;
  addressToValidate: any;
  validatedAddress: any;
  addressValidationError: any;
  typeform: FormGroup;
  isPoBox: boolean;
  validationModalId: '#address_validation_modal';

  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    if (this.socoHttp.sessionActive) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constantsSvc.changes;
    }
  }

  // constructor
  constructor(
    public wizardSvc: MultistepsService,
    public sessionSvc: SessionService,
    public constantsSvc: ConstantsService,
    public lookupSvc: LookupsService,
    private usps: UspsService,
    private socoHttp: SocoHttpService,
    public alertService: AlertService) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.ADDRESSES);
  }

  // used to close opened pop ups
  ngOnDestroy() {
    if ($('#address_validation_modal').is(':visible')) {
      $('#address_validation_modal').modal('hide');
    }
  }

  // used to subscribe to services and call initial methods
  ngOnInit() {
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.ADDRESSES).form;
    this.isPoBox = this.form.controls['isPoBox'].value;
    this.typeform = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;
    if (this.typeform.value.propertyType.id === 'SUBDIVISION') {
      this.form.controls['serviceDevelopementName'].setValidators(Validators.required);
      this.form.updateValueAndValidity();
    } else {
      this.form.controls['serviceDevelopementName'].clearValidators();
      this.form.updateValueAndValidity();
    }
    this.locationform = this.wizardSvc.getStepById(this.stepsIdEnum.LOCATION).form;

    if (this.wizardSvc.addressChanged) {
      this.form.controls['mailingAddressSame'].setValue(null);
      this.cloneServiceAddress(false);
      this.wizardSvc.addressChanged = false;
    }
    this.form.patchValue({
      serviceStreetNumber: this.wizardSvc.serviceAddress.street_number,
      serviceStreetName: this.wizardSvc.serviceAddress.street_name,
      serviceZip: this.wizardSvc.serviceAddress.zip,
      serviceState: this.lookupSvc.serviceState.find(x =>
        x.id.toUpperCase() === this.wizardSvc.serviceAddress.state.short_name.toUpperCase()),
      serviceCity: this.lookupSvc.serviceCity.find(x => x.itemName.toUpperCase() === this.wizardSvc.serviceAddress.city.toUpperCase()),
    });

    // filling customer requested address as service address

    this.form.patchValue({
      customerStreetNumber: !this.wizardSvc.customerRequested ? this.wizardSvc.serviceAddress.street_number :
        this.form.controls['customerStreetNumber'].value,
      customerStreetName: !this.wizardSvc.customerRequested ? this.wizardSvc.serviceAddress.street_name :
        this.form.controls['customerStreetName'].value,
      customerZip: this.wizardSvc.serviceAddress.zip,
      customerState: this.lookupSvc.serviceState.find(x =>
        x.id.toUpperCase() === this.wizardSvc.serviceAddress.state.short_name.toUpperCase()),
      customerCity: this.lookupSvc.serviceCity.find(x => x.itemName.toUpperCase() === this.wizardSvc.serviceAddress.city.toUpperCase()),

      customerCounty: this.lookupSvc.serviceCounty.length > 0 ?
        this.lookupSvc.serviceCounty.find(x => x.itemName.toUpperCase() === this.wizardSvc.serviceAddress.county.toUpperCase()) : null
    });


    if (this.locationform.controls['locationStreetNumber'].value !== null && this.locationform.controls['locationStreetNumber'].value !== ''
      && this.locationform.controls['locationStreetNumber'].value !== undefined) {
      this.form.controls['customerStreetNumber'].setValue(this.locationform.controls['locationStreetNumber'].value);
    }
    if (this.locationform.controls['locationStreetName'].value !== null && this.locationform.controls['locationStreetName'].value !== '' &&
      this.locationform.controls['locationStreetName'].value !== undefined) {
      this.form.controls['customerStreetName'].setValue(this.locationform.controls['locationStreetName'].value);
    }
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
        this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Site Details Builder'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
    this.resolveMailingZip();
  }
  ngAfterViewInit() { this.listenMailingAddressChanges(); }

  // used to resolve zip code
  resolveMailingZip() {
    this.form.controls['mailingZip'].valueChanges.subscribe(selectedValue => {
      if (this.form.get('mailingAddressSame').value) { return; }
      if (this.constantsSvc.zipCodePattern.test(selectedValue)) { // We have a valid ZIP Code.
        this.wizardSvc.addressValidationDone = false;
        this.socoHttp.showPleaseWait('Processing.', 'ContainerAwaiter');
        this.usps.GetCityStateFromZip(selectedValue, (result) => {
          if (result.CityStateLookupResponse.ZipCode.Error) {
            this.form.patchValue({ mailingZip: null, mailingCity: null, mailingState: null });
            this.socoHttp.hidePleaseWait('ContainerAwaiter');
            swal(this.constantsSvc.invalidZipSwal, '', this.constantsSvc.errorSwal);
            return;
          }
          this.lookupSvc.loadMailingAddressCityLookups(result.CityStateLookupResponse.ZipCode.State,
            result.CityStateLookupResponse.ZipCode.City);
          this.lookupSvc.mailingAddressLookupsLoaded$.subscribe(loaded => {
            if (loaded) {
              this.socoHttp.hidePleaseWait('ContainerAwaiter');
              this.form.patchValue({
                mailingCity: this.lookupSvc.mailingCity.length > 0 ? this.lookupSvc.mailingCity[0] : null,
                mailingState: this.lookupSvc.mailingState.length > 0 ? this.lookupSvc.mailingState[0] : null,
              });
            }
          }, fail => { this.socoHttp.hidePleaseWait('ContainerAwaiter'); });
        });
      }
    });
  }

  // method to listen to mailing address changes
  listenMailingAddressChanges() {
    this.form.controls['mailingStreetNumber'].valueChanges.subscribe(value => { this.wizardSvc.addressValidationDone = false; });
    this.form.controls['mailingStreetName'].valueChanges.subscribe(value => { this.wizardSvc.addressValidationDone = false; });
    this.form.controls['mailingUnitNumber'].valueChanges.subscribe(value => { this.wizardSvc.addressValidationDone = false; });
  }
  next() { this.wizardSvc.nextStep(); }
  back() { this.wizardSvc.previousStep(); }

  // used to handle page refresh
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    if (this.form) {
      // If form is invalid, then warning dialogs will appear, don't ask for address validation.
      const isFormValid = this.wizardSvc.canDeactivateStep(route, state, nextState);
      if (this.wizardSvc.addressValidationDone || this.form.controls['isPoBox'].value) { return isFormValid; }

      if (this.form.valid) {
        const currentPath = state.url.substring(state.url.lastIndexOf('/') + 1, state.url.length).trim().toLowerCase();
        const nextPath = nextState.url.substring(nextState.url.lastIndexOf('/') + 1, nextState.url.length).trim().toLowerCase();
        // If we moving forward to next step, make sure address is valid.
        if (currentPath === StepsRouteEnum.ADDRESSES && nextPath === StepsRouteEnum.PREMISE) {
          this.addressToValidate = {
            street: (this.form.getRawValue().mailingStreetNumber + ' ' + this.form.getRawValue().mailingStreetName).toUpperCase(),
            city: this.form.getRawValue().mailingCity.itemName.toUpperCase(),
            state: this.form.getRawValue().mailingState.id.toUpperCase(),
            zip: this.form.getRawValue().mailingZip
          };
          if (!this.wizardSvc.addressValidationDone && this.addressToValidate) {
            this.usps.GetValidatedAddress(this.addressToValidate, (result) => {
              if (result.Error) {
                this.addressValidationError = result.Error.Description;
              } else {
                this.validatedAddress = result;
              }

              if (compareObjects(this.addressToValidate, this.validatedAddress)) {
                this.wizardSvc.addressValidationDone = true;
                this.wizardSvc.goToStep(StepsIdEnum.PREMISE);
              } else { $('#address_validation_modal').modal('show'); }
            });
            return false;
          } else {
            return false;
          }
        } else { return true; }
      } else { return isFormValid; }
    } else { return true; }
  }

  getAddressFromModal(selectedAddress) {
    // Address to validate is same as validated one.
    if (!compareObjects(this.addressToValidate, selectedAddress)) {
      // 'Address not identical, update the form');
      this.form.patchValue({ mailingStreetName: selectedAddress.street.substr(selectedAddress.street.indexOf(' ') + 1) });
    }
    $('#address_validation_modal').modal('hide');
    this.form.updateValueAndValidity();
    this.wizardSvc.addressValidationDone = true;  // Address validated
    this.wizardSvc.goToStep(StepsIdEnum.PREMISE); // Route to premise
  }

  modalChangeMailingAddress() {
    $('#address_validation_modal').modal('hide');
    this.cloneServiceAddress(false);
    this.form.get('mailingAddressSame').setValue(false);
    focusFirstInvalidField(this.form);
  }

  gotoLocationStep() {
    this.wizardSvc.changeAddressClicked = true;
    this.wizardSvc.goToStep(this.stepsIdEnum.LOCATION);
  }

  // method to toggle to input mailing address
  mailingAddressToggle(eve: any) {
    const mailingAddressSame = <FormControl>(this.form.get('mailingAddressSame'));
    if (mailingAddressSame.value) {
      this.form.controls['isPoBox'].patchValue(false);
      this.form.controls['poBoxAddress'].clearValidators();
      this.isPoBox = false;
      this.form.controls['poBoxAddress'].setValue('');
    }
    this.cloneServiceAddress(mailingAddressSame.value);
  }

  // method to toggle to input PO
  PoBoxToggle(e) {
    this.isPoBox = this.form.controls['isPoBox'].value;
    if (this.isPoBox) {
      this.form.controls['mailingAddressSame'].setValue(false);
      this.form.controls['poBoxAddress'].setValidators([Validators.required,
      Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
      this.form.controls['mailingStreetName'].clearValidators();
      this.form.controls['mailingStreetNumber'].clearValidators();
      this.form.controls['poBoxAddress'].enable();
    } else {
      this.form.controls['poBoxAddress'].clearValidators();
      this.form.controls['poBoxAddress'].setValue('');
      this.form.controls['mailingStreetName'].patchValue(null);
      this.form.controls['mailingStreetName'].setValidators([Validators.required,
        Validators.pattern(this.constantsSvc.alphaNumericPattern)]);
      this.form.controls['mailingStreetNumber'].patchValue(null);
      this.form.controls['mailingStreetNumber'].setValidators([Validators.required,
        Validators.pattern(this.constantsSvc.numericPatternwithZero)]);
        this.form.controls['mailingUnitNumber'].patchValue(null);
        this.form.controls['mailingUnitNumber'].setValidators([
          Validators.pattern(this.constantsSvc.alphaNumericPattern)]);
        this.form.controls['poBoxAddress'].disable();
      this.isPoBox = false;

      this.form.controls['mailingStreetNumber'].enable();
      this.form.controls['mailingStreetName'].enable();
      this.form.controls['mailingUnitNumber'].enable();
      this.form.controls['mailingZip'].enable();
    }
  }

  // used to clone service address
  cloneServiceAddress(same: boolean) {
    if (same) {
      this.form.patchValue({
        mailingStreetNumber: this.form.controls['customerStreetNumber'].value,
        mailingStreetName: this.form.controls['customerStreetName'].value,
        mailingUnitNumber: this.form.controls['serviceUnitNumber'].value,
        mailingZip: this.form.controls['serviceZip'].value,
        mailingCity: this.form.controls['serviceCity'].value ? this.form.controls['serviceCity'].value : [],
        mailingState: this.form.controls['serviceState'].value ? this.form.controls['serviceState'].value : []
      });
      this.form.controls['mailingStreetNumber'].disable();
      this.form.controls['mailingStreetName'].disable();
      this.form.controls['mailingUnitNumber'].disable();
      this.form.controls['mailingZip'].disable();
    } else {
      this.form.patchValue({
        mailingStreetNumber: '',
        mailingStreetName: '',
        mailingUnitNumber: '',
        mailingZip: '',
        mailingCity: [],
        mailingState: []
      });
      this.form.controls['mailingStreetNumber'].enable();
      this.form.controls['mailingStreetName'].enable();
      this.form.controls['mailingUnitNumber'].enable();
      this.form.controls['mailingZip'].enable();
      this.wizardSvc.addressValidationDone = false;
    }
    this.form.updateValueAndValidity();
  }

  // if user clicks on edit to enter different address
  editCustomerAddress() {
    this.wizardSvc.customerRequested = true;
    this.form.controls['customerStreetNumber'].enable();
    this.form.controls['customerStreetName'].enable();
    this.wizardSvc.customerAddress.streetNumber = this.form.controls['customerStreetNumber'].value;
    this.wizardSvc.customerAddress.streetName = this.form.controls['customerStreetName'].value;
  }

  // if user clicks on reset
  resetCustomerAddress() {
    this.wizardSvc.customerRequested = false;

    if (this.locationform.controls['locationStreetNumber'].value !== null &&
      this.locationform.controls['locationStreetNumber'].value !== ''
      && this.locationform.controls['locationStreetNumber'].value !== undefined) {
      this.form.controls['customerStreetNumber'].setValue(this.locationform.controls['locationStreetNumber'].value);
    } else {
      this.form.controls['customerStreetNumber'].setValue(this.wizardSvc.serviceAddress.street_number);
    }
    if (this.locationform.controls['locationStreetName'].value !== null &&
      this.locationform.controls['locationStreetName'].value !== '' &&
      this.locationform.controls['locationStreetName'].value !== undefined) {
      this.form.controls['customerStreetName'].setValue(this.locationform.controls['locationStreetName'].value);
    } else {
      this.form.controls['customerStreetName'].setValue(this.wizardSvc.serviceAddress.street_name);
    }


    this.form.controls['customerStreetNumber'].disable();
    this.form.controls['customerStreetName'].disable();

    if (this.form.controls['mailingAddressSame'].value) {
      this.form.controls['mailingAddressSame'].setValue(false);

      this.form.patchValue({
        mailingStreetNumber: '',
        mailingStreetName: '',
        mailingUnitNumber: '',
        mailingZip: '',
        mailingCity: [],
        mailingState: []
      });
      this.form.controls['mailingStreetNumber'].enable();
      this.form.controls['mailingStreetName'].enable();
      this.form.controls['mailingUnitNumber'].enable();
      this.form.controls['mailingZip'].enable();
      this.wizardSvc.addressValidationDone = false;
    }

  }
}
